export const NOTIFICATION_TIMER = 2000;
export const TIMER = 2000;
export const UNCONFIRMED_NEEDS_THRESHOLD = 120;
export const PRODUCT_UNPAYABLE_PERIOD = 14
